import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// ==================== 序列配置 ====================
export function seqConfigList(data) {
  return axios.post(`${base.url}/business/seqConfig/list`, qs.stringify(data))
}
export function seqConfigAddOrUpdate(data) {
  return axios.post(`${base.url}/business/seqConfig/addOrUpdate`, qs.stringify(data))
}
// 单条新增：序列类型不可重复（后端校验，重复时返回错误信息）
export function seqConfigAdd(data) {
  return axios.post(`${base.url}/business/seqConfig/add`, qs.stringify(data))
}
export function seqConfigDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/seqConfig/deleteBatchIds`, qs.stringify({ ids }))
}
export function seqConfigStatus(ids, status) {
  return axios.post(`${base.url}/business/seqConfig/status`, qs.stringify({ ids, status }))
}
export function seqConfigSaveAll(data) {
  return axios.post(`${base.url}/business/seqConfig/saveAll`, JSON.stringify(data),
    { headers: { 'Content-Type': 'application/json' } })
}
